import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelperService } from '../helper.service';
import { PicklistsService } from '../picklists.service';
import { Registrations } from '../registration.model';
import { RegistrationService } from '../registration.service';

@Component({
  selector: 'app-register-self-service',
  templateUrl: './register-self-service.component.html',
  styleUrls: ['./register-self-service.component.css']
})
export class RegisterSelfServiceComponent implements OnInit {

  //declare variables
  reg: Registrations = new Registrations();
  bRobot: boolean = false;
  bLicense: boolean = false;
  cases: any[];
  pwd: string = 'ATL$$1ty##2020c2labs';

  //inject services
  constructor(private rs: RegistrationService, private router: Router, private hs: HelperService, private pls: PicklistsService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    //get metadata
    this.cases = this.pls.getUseCases();

    //get the parameters passed to the component
    this.route.paramMap.subscribe(p => {
      //retrieve the ID from the URL parameters (+ converts to a number)
      if (p.get('uuid') != null) {
        this.reg.instanceId = p.get('uuid');
      }
    });
  }

  //save a new contact
  save() {
    if (this.reg.email == '') {
      window.alert("You must provide a valid corporate email address to Register with RegScale.");
    } else if (this.hs.checkEmail(this.reg.email) == false) {
      this.reg.email = '';
      window.alert("You must provide a corporate email to register with RegScale.  Personal emails are not permitted.");
    } else {
      //update some of the data
      this.reg.dateSubmitted = new Date();
      this.reg.id = this.hs.createGUID();
      var strKey = 'Community;50000;2100-12-31;' + this.reg.instanceId + ';';
      this.reg.license = btoa(strKey);
      this.reg.eulaAccepted = true;

      //save the record
      this.rs.save(this.reg);

      //clear the form
      this.bRobot = false;

      //navigate to the thank you page
      this.router.navigate(['/thank-you/register/' + encodeURIComponent(this.reg.id)]);
    }
  }

  //check for personal email
  checkEmail() {
    if (this.hs.checkEmail(this.reg.email) == false) {
      this.reg.email = '';
      window.alert("You must provide a corporate email to register with RegScale.  Personal emails are not permitted.");
    }
  }

}
